<template>
  <div class="word_pk_page">
    <div class="read_content">
      <div class="read_content_hd">
        <div class="navigation">
          <div class="left">
            <div>&nbsp;</div>
            <div class="back-btn" @click="backRoute"></div>
          </div>
          <div class="center">选择难度</div>
          <div class="right">
            &nbsp;
          </div>
        </div>
      </div>
      <div class="read_content_bd">
        <div class="items">
          <div class="card_wrap" v-for="(item,index) in items" v-bind:key="index">
            <div class="card" @click="select_level(item.id)">
              <div class="card_hd">
                <img src="~assets/famous/level_icon.png" alt="">
              </div>
              <div class="card_bd">
                <div class="card_text">{{ item.title }}</div>
                <div class="card_desc">{{item.desc}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFamousLevels } from '../../services'

export default {
  name: 'famous_read_levels',
  components: {},
  data() {
    return {
      items: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    select_level(level_id) {
      this.$router.push({
        path: '/famous_read',
        query: {
          level_id:level_id,
        }
      })
    },
    async init() {
      getFamousLevels().then((res)=>{
        this.items = res.data.list;
      });
    },
    backRoute() {
      this.$router.back();
    }
  },
}
</script>
<style lang="less" scoped>
.word_pk_page {
  display: block;
  height: 100%;
  width: 100%;
}

.read_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-size: 1620px 817px;
  background: url(~assets/yxp-bg.png) no-repeat center center;
}

.read_content_hd {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.select_level_btn{
  font-size: 1rem;
  padding:.25rem .56rem;
  border-radius: .3rem;
  background-color: #fff;
}

.ui-tab-content {
  display: block;
  height: 100%;
  width: 100%;
}

.navigation {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  width: 100%;
  background-color: #fff;
  height: 60px;
  text-align: center;
  padding: 0 40px;

  .left {
    flex: 1;
    display: flex;
    text-align: right;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .center {
    flex: 1;
    font-size: 20px;
    font-weight: bold;
  }

  .right {
    flex: 1;
    display: flex;
    text-align: right;
    align-content: center;
    align-items: center;
    justify-content: flex-end;
  }
}

.read_content_bd {
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100vh - 80px);
  overflow: auto;
}



.back-btn {
  display: block;
  width: 30px;
  height: 27px;
  background: url(~assets/word/back-icon.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}


.items {
  display: block;
  width: 600px;
  margin: 1rem auto 0;

  .card_wrap {
    display: block;
    padding: .5rem;
    box-sizing: border-box;
    .card {
      width: 100%;
      cursor: pointer;
      background: #fff;
      padding: .5rem;
      border-radius: 5px;
      display: flex;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      img {
        border-radius: 5px;
      }
      .card_hd{
        padding-right: .5rem;
      }
      .card_text {
        font-weight: bold;
        font-size: 1.2rem;
      }
      .card_desc {
        font-size: 1rem;
      }
    }
  }
}

.submit-btn {
  display: inline-block;
  min-width: 140px;
  height: 46px;
  line-height: 46px;
  margin-left: .5rem;

  .ui-btn {
    padding: 0;
  }
}

</style>